// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Axis path,.Axis line{stroke:#E0E0E0;opacity:0.7}.Axis text{font-size:10px;fill:black;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.Axis-Bottom text{transform:rotate(0deg);text-anchor:end}\n", ""]);
// Exports
module.exports = exports;
